import { Link, useLocation } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";

const wings = [
  {
    slug: "/wings/innovation",
    name: "Innovation Wing",
    icon: "ri-flashlight-line",
    description: "Factory-facing innovation engine",
  },
  {
    slug: "/wings/research",
    name: "Research Wing",
    icon: "ri-microscope-line",
    description: "Evidence-based sector research",
  },
  {
    slug: "/wings/readiness",
    name: "Readiness & Recognition",
    icon: "ri-award-line",
    description: "Certification & awards",
  },
  {
    slug: "/wings/expo",
    name: "Expo Wing",
    icon: "ri-store-2-line",
    description: "B2B innovation marketplace",
  },
];

export default function WingPathwayNav() {
  const location = useLocation();

  return (
    <section className="bg-tie-grey-light py-16 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-navy/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-navy uppercase tracking-wider">
                  / Explore Other Wings
                </span>
              </div>
              <h2 className="font-serif text-xl md:text-2xl lg:text-3xl font-bold text-tie-text-primary leading-tight">
                The Four Wings of TIE
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {wings.map((wing, index) => {
              const isActive = location.pathname === wing.slug;
              return (
                <ScrollReveal key={wing.slug} delay={index * 100}>
                  <Link
                    to={wing.slug}
                    className={`group block p-5 md:p-6 rounded-xl border transition-all duration-300 ${
                      isActive
                        ? "bg-tie-navy border-tie-navy text-white"
                        : "bg-white border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-lg"
                    }`}
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${isActive ? "bg-white/15" : "bg-tie-teal/10"}`}>
                        <i className={`${wing.icon} ${isActive ? "text-tie-teal-light" : "text-tie-teal"} text-lg`} />
                      </div>
                      <span className={`text-xs font-semibold uppercase tracking-wider ${isActive ? "text-white/60" : "text-tie-text-muted"}`}>
                        Wing
                      </span>
                    </div>
                    <h3 className={`text-base md:text-lg font-semibold mb-1 ${isActive ? "text-white" : "text-tie-text-primary"}`}>
                      {wing.name}
                    </h3>
                    <p className={`text-sm ${isActive ? "text-white/60" : "text-tie-text-secondary"}`}>
                      {wing.description}
                    </p>
                  </Link>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}